import React, { FC } from 'react';
import { FullCategoryNodeFragment } from 'types';

import { CategoryHeader } from './components/CategoryHeader/CategoryHeader';
import { GetPageDataReturnData } from 'lib/posts';
import { Page } from 'components/Page';
import { Head } from 'layouts';

export interface CategoryPostsProps {
  posts: GetPageDataReturnData;
  categoryData: FullCategoryNodeFragment;
}

export const CategoryPosts: FC<CategoryPostsProps> = (props) => {
  return (
    <CategoryHeader data={props.categoryData}>
      <Page
        {...props.posts}
        pageUrlPrefix={`/category/${props.categoryData.slug}`}
      />
    </CategoryHeader>
  );
};
